import { type AbilityBuilder, type AnyAbility } from '@casl/ability';

export default function getAclProviderConfig({
	can,
	userData
}: {
	can: AbilityBuilder<AnyAbility>['can'];
	userData: any;
}) {
	// Add here custom permissions
}
